export default "__VITE_ASSET__c42d60c4__"